import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	agile: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.agile',
		defaultMessage: 'Agile',
		description: 'Agile links group title',
	},
	burndown: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.burndown',
		defaultMessage: 'Burndown Chart',
		description: 'Burndown Chart link item',
	},
	burnup: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.burnup',
		defaultMessage: 'Burnup Chart',
		description: 'Burnup Chart link item',
	},
	sprint: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.sprint',
		defaultMessage: 'Sprint Report',
		description: 'Sprint Report link item',
	},
	velocity: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.velocity',
		defaultMessage: 'Velocity Chart',
		description: 'Velocity Chart link item',
	},
	flow: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.flow',
		defaultMessage: 'Cumulative Flow Diagram',
		description: 'Cumulative Flow Diagram link item',
	},
	version: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.version',
		defaultMessage: 'Version Report',
		description: 'lVersion Report ink item',
	},
	epic: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.epic',
		defaultMessage: 'Epic Report',
		description: 'Epic Report link item',
	},
	epicReportFlexible: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.epic-report-flexible',
		defaultMessage: '{epicLevelName} Report',
		description: 'Epic Report link item',
	},
	control: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.control',
		defaultMessage: 'Control Chart',
		description: 'Control Chart link item',
	},
	epicBurndown: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.epic-burndown',
		defaultMessage: 'Epic Burndown',
		description: 'Epic Burndown link item',
	},
	epicBurndownFlexible: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.epic-burndown-flexible',
		defaultMessage: '{epicLevelName} Burndown',
		description: 'Epic Burndown link item',
	},
	releaseBurndown: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.agile.release-burndown',
		defaultMessage: 'Release Burndown',
		description: 'Release Burndown link item',
	},
});
